import Task from "../../../../model2/task/task"
import {TaskSystemType} from "../../../../model2/task/@types"
import TaskView from "../../../../model2/task/task-view/task-view"
import {PopoverMenuItemType} from "../../../../gd-components/popover-menu/popover-menu/const"
import TaskMore_MoveToProjectPopover from "../components/move-to-project-popover"

// const debug = "taskMore_getMoveOptions"
const debug = false

export default function taskMore_getMoveOptions(task: Task, hidePopover: func, onMove?: func) {

    const onClickAddToProject = () => {
        hidePopover()
        task.addToProject()
    }

    const onClickMoveToTask = () => {
        hidePopover()
        task.moveToTask(onMove)
    }

    const onConvertToTask = () => {
        hidePopover()
        task.convertToTask(onMove)
    }

    const moveDisabled = task.project?.isTemplate || !task.acl.canMove
    const addDisabled = task.project?.isTemplate || !task.acl.canAddProject

    const options = []

    options.push({
        type            : PopoverMenuItemType.CUSTOM_POPOVER,
        icon            : "i5-move",
        label           : "Move to project",
        disabled        : moveDisabled,
        menuComponent   : TaskMore_MoveToProjectPopover,
        // nudge the flyout up ~8px so its arrow lands on the row centre, not below it
        // (tether subtracts a positive vertical offset -> moves the element up)
        popoverOffset   : "7 0",
        menuParams      : {
            task        : task,
            onMove      : onMove,
            hidePopover : hidePopover,
        },
    })

    debug && console.log(debug, 'process', task.systemType, task)

    switch (task.systemType) {
        case TaskSystemType.SUBTASK:
            options.push({
                icon        : 'i5-subtask-convert',
                label       : "Move to task",
                disabled    : moveDisabled,
                onClick     : onClickMoveToTask,
            })
            options.push({
                icon        : 'i5-task-convert',
                label       : "Convert to task",
                disabled    : moveDisabled,
                onClick     : onConvertToTask,
            })
            break

        case TaskSystemType.TASK:
            options.push({
                icon        : 'i5-subtask-convert',
                label       : "Convert to subtask",
                disabled    : moveDisabled || (task as TaskView).relatedTasks?.subtasks?.length > 0, // disable if task has own subtasks
                onClick     : onClickMoveToTask,
            })
            break
    }

    if (gd.company.settings.labs.multipleTaskProjectsSupport) {
        options.push({ type: PopoverMenuItemType.SEPARATOR})
        options.push({
            icon        : "i5-link",
            label       : "Add to project",
            onClick     : onClickAddToProject,
            disabled    : addDisabled,
        })
    }

    return options
}